import { z } from "zod";

export const DisableIntegrationRequestPathParamSchema = z.object({
  id: z.string().uuid(),
});

export type DisableIntegrationRequestPathParamType = z.infer<
  typeof DisableIntegrationRequestPathParamSchema
>;

export const DisableIntegrationResponseBodySchema = z.string();

export type DisableIntegrationResponseBodyType = z.infer<
  typeof DisableIntegrationResponseBodySchema
>;
